$(window).load(function(){ 

  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 4000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  
  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });
    
  
  
//  var s = $("#isofilter");
//  var pos = s.offset();                    
//  $(window).scroll(function() {
//      var windowpos = $(window).scrollTop();
//      if (windowpos >= pos.top - 172) {
//          s.addClass("stick");
//      } else {
//          s.removeClass("stick"); 
//      }
//  });

}); // end window load


$(document).ready(function($){
  
  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  $('#product .add-to-cart').click(function(e){
    $('#add-item-to-cart').click();
  });
  
  // stop the scroll to top on # links
  $('[href="#"]').click(function (m) {
      m.preventDefault();
  });
  
  // remove ugly outline on input button click
  $('input[type="submit"], input.btn, button').click(function(){
    $(this).blur();
  })
  
}); // end document ready